// This file is generated automatically, do NOT modify it.

import * as ImportedUserApi from "./modules/user";
import * as ImportedAuthApi from "./modules/auth";
import * as ImportedSubmissionApi from "./modules/submission";
import * as ImportedProblemApi from "./modules/problem";
import * as ImportedMigrationApi from "./modules/migration";
import * as ImportedGroupApi from "./modules/group";
import * as ImportedJudgeClientApi from "./modules/judge-client";
import * as ImportedDiscussionApi from "./modules/discussion";
import * as ImportedHomepageApi from "./modules/homepage";

export const user = ImportedUserApi;
export const auth = ImportedAuthApi;
export const submission = ImportedSubmissionApi;
export const problem = ImportedProblemApi;
export const migration = ImportedMigrationApi;
export const group = ImportedGroupApi;
export const judgeClient = ImportedJudgeClientApi;
export const discussion = ImportedDiscussionApi;
export const homepage = ImportedHomepageApi;
